// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".api-key[data-v-9fc9c776],\n.api-expires[data-v-9fc9c776] {\n  font-family: monospace;\n  font-weight: bold;\n  font-size: 22px;\n  color: #9e0000;\n}", ""]);
// Exports
module.exports = exports;
